import { dateToFilterFormat } from '@/composables/useDateService'

export const Promotion = (json: IPromotion): IPromotionModel => {
	const fromJSON = (itemJson: IPromotion) => {
		const {
			is_exclusive,
			usage_count,
			usage_limit,
			is_coupon_based,
			starts_at,
			ends_at,
			applies_to_discounted,
			created_at,
			updated_at,
			actions,
			coupons,
			rules,
			is_active,
			...rest
		} = itemJson
		return {
			isExclusive: is_exclusive,
			usageCount: usage_count,
			usageLimit: usage_limit,
			isCouponBased: is_coupon_based,
			startsAt: starts_at,
			endsAt: ends_at,
			appliesToDiscounted: applies_to_discounted,
			createdAt: created_at,
			updatedAt: updated_at,
			isActive: is_active,
			actions: actions ? actions.map(PromotionAction) : [],
			coupons: coupons ? coupons.map(Coupon) : [],
			rules: rules ? rules.map(PromotionRule) : [],

			...rest,
		}
	}

	return { ...fromJSON(json) }
}

const toDateOnlyString = (value: string | Date | null | undefined) => (value ? dateToFilterFormat(value) : null)

export const promotionToJSON = (obj: Partial<IPromotionModel>): Partial<IPromotion> => {
	const {
		isCouponBased,
		isExclusive,
		appliesToDiscounted,
		usageLimit,
		startsAt,
		endsAt,
		isActive,
		actions: _actions,
		coupons: _coupons,
		rules: _rules,
		...rest
	} = obj
	return {
		...rest,
		is_coupon_based: isCouponBased ?? true,
		is_exclusive: isExclusive ?? false,
		applies_to_discounted: appliesToDiscounted ?? false,
		usage_limit: usageLimit ?? null,
		is_active: isActive ?? false,
		starts_at: toDateOnlyString(startsAt),
		ends_at: toDateOnlyString(endsAt),
	}
}
